import { render, staticRenderFns } from "./TransientDash.vue?vue&type=template&id=c2adafd0"
import script from "./TransientDash.vue?vue&type=script&lang=js"
export * from "./TransientDash.vue?vue&type=script&lang=js"
import style0 from "./TransientDash.vue?vue&type=style&index=0&id=c2adafd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports